export interface URLCategory {
    value: string;
    label: string;
    footerLabel: string;
    path: string;
    priority: number;
}

export interface URLSType{
    path: string;
    category:URLCategory;
    subGroups?:Array<URLCategory>;
}

export const urls: Array<URLSType> = [
    {
        path: "/formatters",
        category: {
            value: "formatters",
            label: "Formatters",
            footerLabel: "Code Formatters",
            path: "/formatters",
            priority: 1
        },
        subGroups: [
            {
                value: "json",
                label: "JSON Formatter",
                footerLabel: "JSON Formatter & Validator",
                path: "/json",
                priority: 1
            },
            {
                value: "xml",
                label: "XML Formatter",
                footerLabel: "XML Formatter & Validator",
                path: "/xml",
                priority: 2
            },
            {
                value: "yaml",
                label: "YAML Formatter",
                footerLabel: "YAML Formatter & Validator",
                path: "/yaml",
                priority: 3
            },
            {
                value: "sql",
                label: "SQL Formatter",
                footerLabel: "SQL Formatter",
                path: "/sql",
                priority: 4
            }
        ]
    },
    {
        path: "/converters",
        category: {
            value: "converters",
            label: "Converters",
            footerLabel: "Format Converters",
            path: "/converters",
            priority: 2
        },
        subGroups: [
            {
                value: "json_to_yaml",
                label: "JSON to YAML",
                footerLabel: "JSON to YAML",
                path: "/json/to/yaml",
                priority: 1
            },
            {
                value: "json_to_xml",
                label: "JSON to XML",
                footerLabel: "JSON to XML",
                path: "/json/to/xml",
                priority: 2
            },
            {
                value: "xml_to_yaml",
                label: "XML to YAML",
                footerLabel: "XML to YAML",
                path: "/xml/to/yaml",
                priority: 3
            },
            {
                value: "xml_to_json",
                label: "XML to JSON",
                footerLabel: "XML to JSON",
                path: "/xml/to/json",
                priority: 4
            },
            {
                value: "yaml_to_json",
                label: "YAML to JSON",
                footerLabel: "YAML to JSON",
                path: "/yaml/to/json",
                priority: 5
            },
            {
                value: "yaml_to_xml",
                label: "YAML to XML",
                footerLabel: "YAML to XML",
                path: "/yaml/to/xml",
                priority: 6
            }
        ]
    },
    {
        path: "/diffchecker",
        category: {
            value: "diffchecker",
            label: "Diff Checker",
            footerLabel: "Compare and find differences between texts",
            path: "/diffchecker",
            priority: 3
        }
    },
    {
        path: "/jsonpath",
        category: {
            value: "jsonpath",
            label: "JSONPath",
            footerLabel: "Evaluate JSONPath expressions",
            path: "/jsonpath",
            priority: 4
        }
    },
    {
        path: "/encoders",
        category: {
            value: "encoders",
            label: "Encoders",
            footerLabel: "Text Encoders & Decoders",
            path: "/encoders",
            priority: 5
        },
        subGroups: [
            {
                value: "base64",
                label: "Base64 Encoder/Decoder",
                footerLabel: "Base64 Encoder & Decoder",
                path: "/base64",
                priority: 1
            },
            {
                value: "url_encoder",
                label: "URL Encoder/Decoder",
                footerLabel: "URL Encoder & Decoder",
                path: "/url-encoder",
                priority: 2
            }
        ]
    }
]

export interface FlatTool {
    value: string;
    label: string;
    path: string;
    group: string;
}

export const flattenTools = (): Array<FlatTool> => {
    const tools: Array<FlatTool> = [];
    urls.forEach((url) => {
        if (url.subGroups && url.subGroups.length > 0) {
            url.subGroups.forEach((subGroup) => {
                tools.push({
                    value: subGroup.value,
                    label: subGroup.label,
                    path: subGroup.path,
                    group: url.category.label,
                });
            });
        } else {
            tools.push({
                value: url.category.value,
                label: url.category.label,
                path: url.path,
                group: url.category.label,
            });
        }
    });
    return tools;
};